const path = `creditGroups`;

export const state = {
};

export const getters = {
};

export const mutations = {
};

export const actions = {

	consumeCredit(store, { id }) {
		return this._vm.$http.get(`/${path}/${id}/consumeCredit`)
			.then(response => response.data ? response.data.status : null);
	},

	// --- Generic Methods
	[`fields`]() {
		return this._vm.$http.get(`/${path}/fields`);
	},
	[`getAll`]() {
		return this._vm.$http.get(`/${path}`);
	},
	[`getAllOfClient`](store, {clientId}) {
		return this._vm.$http.get(`/${path}/ofclient/${clientId}`);
	},
	[`getAllOfClientCsv`](store, {clientId}) {
		return this._vm.$http.get(`/${path}/ofclientcsv/${clientId}`);
	},
	[`get`](store, { id }) {
		return this._vm.$http.get(`/${path}/${id}`);
	},
	[`getFull`](store, { id }) {
		return this._vm.$http.get(`/${path}/full/${id}`);
	},
	[`create`](store, data) {
		return this._vm.$http.post(`/${path}`, data);
	},
	[`update`](store, { id, data }) {
		return this._vm.$http.put(`/${path}/${id}`, data);
	},
	[`delete`](store, { id }) {
		return this._vm.$http.delete(`/${path}/${id}`);
	},
	[`deleteAll`]() {
		return this._vm.$http.delete(`/${path}`);
	},
};
